(function () {
  if (typeof window === 'undefined') return;

  function attachHandlers() {
    document.body.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      if (btn.dataset.busy === 'true') return;
      btn.dataset.busy = 'true';
      btn.classList.add('is-loading');

      const variantId = btn.dataset.variantId;
      if (!variantId) {
        btn.dataset.busy = 'false';
        btn.classList.remove('is-loading');
        return;
      }

      try {
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });

        if (!addRes.ok) throw new Error('add failed');
        const item = await addRes.json();

        btn.classList.add('is-success');
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        document.dispatchEvent(new CustomEvent('cart:build'));

        setTimeout(function () {
          btn.classList.remove('is-success');
          btn.dataset.busy = 'false';
          btn.classList.remove('is-loading');
        }, 1400);
      } catch (err) {
        btn.classList.add('is-error');
        setTimeout(function () {
          btn.classList.remove('is-error');
          btn.dataset.busy = 'false';
          btn.classList.remove('is-loading');
        }, 1400);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachHandlers);
  } else {
    attachHandlers();
  }
})();
